import api from "@/shared/services/apiClient";
import type {
  ChatTemplate,
  CreateTemplatePayload,
  UpdateTemplatePayload,
} from "@/features/other-setup/types/chatTemplate";

export const chatTemplateService = {
  getActive: async (): Promise<ChatTemplate[]> => {
    const { data } = await api.get("/chat-templates/active");
    return data;
  },

  getAll: async (): Promise<ChatTemplate[]> => {
    const { data } = await api.get("/chat-templates/list");
    return data;
  },

  create: async (payload: CreateTemplatePayload): Promise<ChatTemplate> => {
    const { data } = await api.post("/chat-templates/create", payload);
    return data;
  },

  update: async (id: string, payload: UpdateTemplatePayload): Promise<ChatTemplate> => {
    const { data } = await api.put(`/chat-templates/update/${id}`, payload);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/chat-templates/delete/${id}`);
  },

  reorder: async (updates: { id: string; sort_order: number }[]): Promise<void> => {
    await api.patch("/chat-templates/reorder", { updates });
  },
};
